<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Pausas</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataPausas"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              v-if="permissaoTotal"
              dark
              color="orangePcm"
              href="/central-de-atendimento/cadastro/pausa/criar"
              target="_blank"
              @click="handleGoToNewPause"
              class="mr-2"
            >
              Criar Pausa
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="4" class="mr-2">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  :href="`/central-de-atendimento/cadastro/pausa/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  @click="atualizarButton($event, item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom v-if="permissaoTotal">
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Pausas: {{ qtdPausas }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import pausasStore from '../_store'
import pausaHttpService from '../_services/pausaHttpService'

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    permissaoTotal: false,
    headers: [
      {
        text: 'Pausa',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Código',
        value: 'codigo',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Tempo',
        value: 'duration',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataPausas: [],
    arrayPermissaoTotal: [process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_TOTAL, process.env.VUE_APP_ADMINISTRADOR],
  }),

  computed: {
    ...mapGetters('pausasHomeModuleCallCenterStore', ['getPausas']),

    numberOfPages() {
      return Math.ceil(this.dataPausas.length / this.itemsPerPage)
    },
    qtdPausas() {
      return this.dataPausas.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'pausasHomeModuleCallCenterStore', pausasStore)

    await this.listarPausas()
    this.dataPausas = [...this.getPausas]
    if(this.dataPausas.length > 0){
      this.dataPausas = this.dataPausas.filter(( pausa ) => pausa.description !== 'autopause' );
    }
   

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()

    arrayPermissions.forEach(permissaoLocalStorage => {
      if (this.arrayPermissaoTotal.includes(permissaoLocalStorage)) {
        this.permissaoTotal = true
      }
    })

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('pausasHomeModuleCallCenterStore', ['listarPausas']),
    ...obtainUserPermissions,

    handleGoToNewPause(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewPause = this.$router.resolve({ name: 'Pausa/criar' })
        window.open(goToNewPause.href, '_blank')
      } else {
        this.$router.push({ name: 'Pausa/criar' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`pausa/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`pausa/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(event, item) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`pausa/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`pausa/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover a pausa "${item.description}"?`)
      if (resultado) {
        try {
          await pausaHttpService.deletePausa(item._id)
          this.dataPausas = this.dataPausas.filter(indexPausa => indexPausa._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>
